import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { LogicalOperator } from 'api/models/FieldTemplate';
import { useTranslation } from 'react-i18next';

interface LogicalOperatorsProps {
  value: LogicalOperator;
  onChange: (group: LogicalOperator) => void;
  disabled?: boolean;
}
export default function LogicalOperators({
  value,
  onChange,
  disabled,
}: LogicalOperatorsProps) {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      sx={{ mb: 1, display: 'flex', justifyContent: 'center' }}
      onChange={(_, val) => {
        if (!val) return;
        onChange(val);
      }}
      disabled={disabled}
    >
      <ToggleButton
        disabled={disabled}
        value={LogicalOperator.AND}
        size="small"
        sx={{
          '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: theme => theme.palette.primary.main,
            color: theme => theme.palette.primary.contrastText,
          },
        }}
      >
        {t('dialogs.addField.logicalOperator.and')}
      </ToggleButton>
      <ToggleButton
        disabled={disabled}
        value={LogicalOperator.OR}
        size="small"
        sx={{
          '&.Mui-selected, &.Mui-selected:hover': {
            backgroundColor: theme => theme.palette.primary.main,
            color: theme => theme.palette.primary.contrastText,
          },
        }}
      >
        {t('dialogs.addField.logicalOperator.or')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
